import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CalculatorPointsModule } from '@cbx-ng-components/calculators';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    //CalculatorPointsModule
  ],
  //bootstrap:[AppComponent],
  providers: []
})
export class AppModule { 
  ngDoBootstrap(): void {}
}
